webpackJsonp([82233384175880],{

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Introduction = function Introduction(_ref) {
	  var sectionName = _ref.sectionName;
	  return React.createElement(
	    "div",
	    { className: "container" },
	    React.createElement(
	      "p",
	      null,
	      "This part of the site is an incomplete guide to SCXML and Statecharts."
	    )
	  );
	};
	
	var WrappedIntroduction = function WrappedIntroduction(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Introduction, pathname: location.pathname });
	};
	
	exports.default = WrappedIntroduction;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-index-js-9c8b83d5503871ad3175.js